export default {"src":"/_next/static/media/twitter.c3a32079.svg","height":14,"width":16};